import { BoxComponentProps } from 'reoil'
import { MAX_WIDTH } from '../constants/media'

export const responseBoxProp: BoxComponentProps = {
  maxWidth: MAX_WIDTH,
  fullWidth: true,
  mx: 'auto'
}